import React from "react";
import { Col, Container, Row } from "react-bootstrap";
import { Link } from "gatsby";
import BgImg from "../../images/services-usa/2d-game/why_choose_game.webp";

function Whychooseecommerce() {
  return (
    <section
      className="trusted_ecommerce_web ecommerce_why_choose p-100"
      style={{
        backgroundImage: `url(${BgImg})`,
        backgroundRepeat: "no-repeat",
        backgroundSize: "cover",
        backgroundPosition: "center",
      }}
    >
      <Container>
        <Row>
          <Col xs={12} md={6} lg={6} xl={6} xxl={6}>
            <h2 style={{ color: "#fff" }}>
              Why Choose TekRevol as Your 2D Game Development Company?
            </h2>
          </Col>
          <Col xs={12} md={6} lg={6} xl={6} xxl={6}>
            <p style={{ color: "#fff" }}>
              When you choose us, you’re not just getting a 2D game development
              service—you’re partnering with industry leaders committed to
              delivering high-performance gaming apps. Our approach is rooted in
              technical excellence, innovation, and a deep understanding of the
              gaming landscape, ensuring your game isn't just another release
              but a standout success.
            </p>
          </Col>
        </Row>
        <Row>
          <Col xs={12} md={12} lg={12} xl={12} xxl={12}>
            <Row className="mt-3 mt-md-5">
              <Col xs={12} md={6} lg={6} xl={4} xxl={4} className="mb-4">
                <div className="trusted_ecomm_box">
                  <div className="ecomm_title">01</div>
                  <div className="ecomm_box_content">
                    <h5>
                      Precision Engine
                      <br />
                      Integration
                    </h5>
                    <p>
                      Expert implementation of Unity or Godot engines tailored
                      to your game’s mechanics and platform requirements.
                    </p>
                  </div>
                </div>
              </Col>
              <Col xs={12} md={6} lg={6} xl={4} xxl={4} className="mb-4">
                <div className="trusted_ecomm_box">
                  <div className="ecomm_title">02</div>
                  <div className="ecomm_box_content">
                    <h5>
                      Advanced Artwork &<br /> Animation
                    </h5>
                    <p>
                      Custom-created sprites and animations using Adobe
                      Photoshop and Unity, optimized for performance and visual
                      impact.
                    </p>
                  </div>
                </div>
              </Col>
              <Col xs={12} md={6} lg={6} xl={4} xxl={4} className="mb-4">
                <div className="trusted_ecomm_box">
                  <div className="ecomm_title">03</div>
                  <div className="ecomm_box_content">
                    <h5>
                      Optimized Game
                      <br /> Architecture
                    </h5>
                    <p>
                      Clean, modular code in C# or GDScript, ensuring
                      scalability, efficient memory usage, and rapid iteration
                      cycles.
                    </p>
                  </div>
                </div>
              </Col>
              <Col
                xs={12}
                md={6}
                lg={6}
                xl={4}
                xxl={4}
                className="mb-4 mb-xl-0"
              >
                <div className="trusted_ecomm_box">
                  <div className="ecomm_title">04</div>
                  <div className="ecomm_box_content">
                    <h5>
                      Adaptive Audio
                      <br /> Design
                    </h5>
                    <p>
                      Integration of FMOD and dynamic audio systems, providing
                      responsive, immersive sound experiences across devices.
                    </p>
                  </div>
                </div>
              </Col>
              <Col
                xs={12}
                md={6}
                lg={6}
                xl={4}
                xxl={4}
                className="mb-xl-0 mb-4"
              >
                <div className="trusted_ecomm_box">
                  <div className="ecomm_title">05</div>
                  <div className="ecomm_box_content">
                    <h5>
                      Multi-Platform
                      <br /> Deployment
                    </h5>
                    <p>
                      Streamlined deployment processes with Unity Cloud Build,
                      ensuring seamless cross-platform compatibility and rapid
                      time-to-market.
                    </p>
                  </div>
                </div>
              </Col>
              <Col
                xs={12}
                md={6}
                lg={6}
                xl={4}
                xxl={4}
                className="mb-xl-0 mb-4"
              >
                <div className="trusted_ecomm_box">
                  <div className="ecomm_title">06</div>
                  <div className="ecomm_box_content">
                    <h5>
                      Data-Driven Game
                      <br /> Optimization
                    </h5>
                    <p>
                      Using data analytics tools we monitor player behavior for
                      continuous performance tuning and feature updates
                      post-launch.
                    </p>
                  </div>
                </div>
              </Col>
            </Row>
          </Col>
        </Row>
      </Container>
    </section>
  );
}

export default Whychooseecommerce;
